import React from "react";
import { FiltersTypes } from "@common/types/filters/general";

interface Props {
    filters: FiltersTypes;
}

export const StartDateFilterLabel: React.FC<Props> = ({ filters }) => {
    const { bookkeepingStartDateStart, bookkeepingStartDateEnd } = filters;

    if (!bookkeepingStartDateStart && !bookkeepingStartDateEnd) {
        return null;
    }

    if (bookkeepingStartDateStart && bookkeepingStartDateEnd) {
        return (
            <span>
                {bookkeepingStartDateStart.toLocaleDateString()} -{" "}
                {bookkeepingStartDateEnd.toLocaleDateString()}
            </span>
        );
    }
};
